var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "chevron-right_svg__nextarrowbox",
    viewBox: "0 0 4 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.154 1.354a.5.5 0 0 1 0-.708.5.5 0 0 1 .706 0l2.994 3a.5.5 0 0 1 .015.692l-2.744 3a.498.498 0 1 1-.736-.676L2.81 4.015z"
  })));
};
export default SvgChevronRight;